import { render } from "./TreeGoods2.vue?vue&type=template&id=ad9efcee&scoped=true"
import script from "./TreeGoods2.vue?vue&type=script&lang=js"
export * from "./TreeGoods2.vue?vue&type=script&lang=js"

import "./TreeGoods2.vue?vue&type=style&index=0&id=ad9efcee&lang=less&scoped=true"
import "./TreeGoods2.vue?vue&type=style&index=1&id=ad9efcee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9efcee"]])

export default __exports__